<template>
  <v-container class="mt-4 pa-0">
    <v-card color="primary" class="elevation-1 mx-auto" :style="{height: '85vh'}">
      <v-toolbar color="primary" flat>
        <v-tooltip bottom>
          <v-toolbar-side-icon slot="activator" @click="$router.push(`/inventory/exceptions`)" icon>
            <v-icon>arrow_back</v-icon>
          </v-toolbar-side-icon>
          <span>Return to List</span>
        </v-tooltip>
        <h2 v-if="currentLocation">
          <a
            target="new"
            :href="
                  `https://ops.bohmtech.com/web#id=${currentLocation[0]}&view_type=form&model=stock.location`
                "
            :style="{ color: '#F04E23', textDecoration: 'none'}"
            class="ml-2"
          >{{ currentLocation[1] }}</a>
        </h2>
        <v-spacer></v-spacer>
        <h3
          :style="{width: '50%', whiteSpace: 'nowrap', overflow: 'hidden',textOverflow: 'ellipsis'}"
          v-if="currentProduct"
        >{{currentProduct[1]}}</h3>
      </v-toolbar>

      <div class="text-xs-center" v-if="currentProduct">
        <v-layout row wrap :style="{marginTop:'10vh',height: '60vh'}">
          <v-flex xs6>
            <v-layout column>
              <h2>Evaluated Quantity: {{exception.enteredValue}}</h2>

              <h2 class="mt-2">Quantity in System: {{exception.correctValue}}</h2>
              <v-expansion-panel
                class="mx-auto mt-4"
                v-if="exception.invalidSerials.length"
                v-model="panel"
                expand
                color="#23292D"
                :style="{width: '90%', textAlign: 'center', opacity: '.8' }"
              >
                <v-expansion-panel-content :style="{backgroundColor: '#23292D'}">
                  <template v-slot:header>
                    <div>
                      <h3>{{exception.correctValue > exception.enteredValue ? 'Missing' : 'Extra'}} Serials</h3>
                    </div>
                  </template>
                  <div class="mx-auto" :style="{maxHeight: '30vh', overflow: 'scroll' }">
                    <div v-for="(item, index) in exception.invalidSerials" :key="index">
                      <h3>{{index+1+'. '+ item }}</h3>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-layout>
          </v-flex>
          <v-flex xs5 class="mx-2">
            <v-layout column>
              <v-select
                :items="results"
                item-text="text"
                item-value="value"
                v-model="result"
                box
                color="secondary"
                label="Select An Exception Result"
              ></v-select>
              <v-text-field
                box
                color="secondary"
                label="Enter Any Additional Notes"
                v-model="notes"
              ></v-text-field>
              <v-btn color="success" @click="submitResult()">Submit</v-btn>
              <v-btn @click="$router.push(`/inventory/exceptions`)">Cancel</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoginCheck from "@/mixins/LoginCheck";

export default {
  name: "InventoryException",
  data() {
    return {
      results: [
        { text: "Unresolved - Investigation Needed", value: "investigation" },
        {
          text: "Resolved - Incorrect Count",
          value: "incorrect"
        },
        { text: "Resolved - Adjustment Made", value: "adjustment" }
      ],
      result: "",
      notes: "",
      panel: [false]
    };
  },
  mixins: [LoginCheck],

  async beforeCreate() {
    await this.$store.dispatch("inventory/getException", this.$route.params.id);
    this.notes = this.exception.notes;
    this.result = this.exception.state;
  },

  computed: {
    ...mapGetters({
      exception: "inventory/getException",
      user: "app/getUser"
    }),

    exceptionModel() {
      return this.exception;
    },

    currentLocation() {
      return this.exception.location;
    },

    currentProduct() {
      return this.exception.product;
    }
  },

  methods: {
    ...mapActions({ updateException: "inventory/updateException" }),

    async submitResult() {
      await this.updateException({
        id: this.exception._id,
        status: this.result,
        resolvedBy: this.user.displayName,
        notes: this.notes
      });

      this.$router.push(`/inventory/exceptions`);
    }
  }
};
</script>

<style>
</style>